module.exports = __webpack_public_path__ + "static/media/070-tuvalu-1.12900d5c.svg";